<template>
 <div class="slider">
  
    <div class="slides">
      <div class="overlay hidden-xs hidden-md"></div>
      <div
        v-for="(slide, index) in slides"
        :key="index"
        :class="['slide', { active: index === currentIndex }]"
      >
        <img class="hidden-xs hidden-sm" v-if="slide.insInstitucionalImagens[0].insListaGaleriaInstImagens.lgiId === 28" :src="$imgURL + slide.insInstitucionalImagens[0].itgUrlImagem" :alt="`Imagem ${index + 1}`" style="width: 100%; height: 500px; overflow-y: hidden; object-fit: cover;"/>
        <video class="hidden-xs hidden-sm" v-else autoplay muted loop playsinline style="width: 100%; height: 500px; overflow-y: hidden; object-fit: cover;">
                <source :src="`${$imgURL + slide.insInstitucionalImagens[0].itgUrlImagem}`" type="video/mp4">
                Seu navegador não suporta a tag de vídeo.
              </video>
              <img 
                  class="hidden-md hidden-lg" 
                  v-if="slide.insInstitucionalImagens[0].insListaGaleriaInstImagens.lgiId === 28"
                  :src="$imgURL + (slide.insInstitucionalImagens.length > 1 ? slide.insInstitucionalImagens[1].itgUrlImagem : slide.insInstitucionalImagens[0].itgUrlImagem)"
                  :alt="`Imagem ${index + 1}`" 
                  style="width: 100%; height: 250px; overflow-y: hidden; object-fit: cover;" 
                />
        <video class="hidden-md hidden-lg" v-else autoplay muted loop playsinline style="width: 100%; height: 250px; overflow-y: hidden; object-fit: cover;">
                <source :src="`${$imgURL + slide.insInstitucionalImagens[0].itgUrlImagem}`" type="video/mp4">
                Seu navegador não suporta a tag de vídeo.
              </video>
        <div class="caption">
          <h2>{{ slide.itiNome }}</h2>
           <div class="hidden-xs hidden-md">{{ slide.itiReferencia }}</div> 
        </div>
        <div class="overlay2 hidden-xs hidden-md"></div>
      </div>
    </div>
    <div class="navigation">
      <span
        v-for="(slide, index) in slides"
        :key="index"
        :class="['dot', { active: index === currentIndex }]"
        @click="goToSlide(index)"
      ></span>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "PageSlider2",
  components: {},
  data: () => ({
    slides: [],
    currentIndex: 0,
    percent: 0,
    interval: null,
  }),
  mounted() {
    this.startSlider();
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    startSlider() {
      this.interval = setInterval(() => {
        this.nextSlide();
      }, 7000); // Timer de 5 segundos
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    },
    goToSlide(index) {
      clearInterval(this.interval);
      this.currentIndex = index;
      this.startSlider(); // Reinicia o timer após clicar
    },
  },
  created() {
      axios.get('/Process/InsInstitucional/institucional/37/slider')
                .then(response => {
                    this.slides = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
                    console.log('this.slides')
                    console.log(this.slides)
                })
                .catch(error => {
                    console.error(error);
                });
  
  },
};
</script>

<style scoped>
/* Slider container */
.slider {
  position: relative;
  width: 100%;
  margin: auto;
  overflow: hidden;
}

.slider .overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 130px; /* Ajuste a altura conforme necessário */
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0)); /* Gradiente que vai de preto transparente */
  z-index: 1; /* Certifique-se de que esteja acima do conteúdo */
}

/* Slides */
.slides {
  display: flex;
  position: relative;
}

/* Individual slide */
.slide {
  min-width: 100%;
  position: absolute;
  opacity: 0;
  transition: opacity 1s ease;
}

.slide.active {
  opacity: 1;
  position: relative;
}

/* Image in the slide */
.slide img {
  width: 100%;
  height: auto;
  transition: transform 40s ease; /* Transição suave para o zoom */
  transform: scale(1); /* Escala inicial */
}

.slide.active img {
  transform: scale(1.1); /* Aumenta a imagem quando a slide está ativa */
}

/* Text in the bottom-left corner */
.caption {
  position: absolute;
  bottom: 60px;
  left: 20px;
  color: white;
  font-size: 18px;
  background-color: rgba(90, 90, 93, 0.5);
  padding: 20px;
  border-radius: 5px;
  font-weight: 500;
  width: 400px;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}
.caption h2 {
  color: white;
  font-size: 40px;
  font-weight: 800;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}

/* Navigation dots */
.navigation {
  text-align: left;
  margin-left: 20px;
  position: absolute;
  bottom: 10px;
  width: 100%;
}

.dot {
  display: inline-block;
  height: 10px;
  width: 10px;
  margin: 0 5px;
  background-color: #333;
  border-radius: 5px;
  width: 15px;
  height: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
}

.dot.active {
  background-color: #ffffff;
  width: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}

@media (max-width:767px) {
/* Text in the bottom-left corner */
.caption {
  position: absolute;
  bottom: 30px;
  left: 20px;
  color: white;
  font-size: 12px;
  background-color: rgba(90, 90, 93, 0.5);
  padding: 10px;
  border-radius: 5px;
  font-weight: 500;
  width: 250px;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}
.caption h2 {
  color: white;
  font-size: 20px;
  font-weight: 800;
  text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.7);
}

.dot {
  display: inline-block;
  height: 10px;
  width: 10px;
  margin: 0 5px;
  background-color: #333;
  border-radius: 5px;
  width: 8px;
  height: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.7);
}

.dot.active {
  background-color: #ffffff;
  width: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
}
}


</style>